import { render, staticRenderFns } from "./TimeSlotsClients.vue?vue&type=template&id=bacf848c&scoped=true"
import script from "./TimeSlotsClients.vue?vue&type=script&lang=js"
export * from "./TimeSlotsClients.vue?vue&type=script&lang=js"
import style0 from "./TimeSlotsClients.vue?vue&type=style&index=0&id=bacf848c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf848c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacf848c')) {
      api.createRecord('bacf848c', component.options)
    } else {
      api.reload('bacf848c', component.options)
    }
    module.hot.accept("./TimeSlotsClients.vue?vue&type=template&id=bacf848c&scoped=true", function () {
      api.rerender('bacf848c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TimeSlotsClients.vue"
export default component.exports